import {
  AVAILABILITY_STATE,
  AvailabilityActionFormUtility,
  BulkAvailabilityState,
  BulkFormAvailabilityMember,
} from 'router/subrouters/DataRoom/models/DataRoomBulk';

export const updateCheckboxValue = (
  config: {
    name: string;
    state: BulkAvailabilityState;
    canDowngrade: boolean;
    onChange: (name: string, value: boolean) => void;
  } & AvailabilityActionFormUtility,
) => {
  const { name, checked, state, isMixed, canDowngrade, onChange } = config;

  if (state === AVAILABILITY_STATE.OFF) {
    onChange(`${name}.checked`, checked);
    return;
  }

  if (state === AVAILABILITY_STATE.ON) {
    if (canDowngrade) {
      onChange(`${name}.checked`, checked);
    }

    return;
  }

  // mixed
  if (checked) {
    onChange(`${name}.checked`, true);
    onChange(`${name}.isMixed`, !isMixed);
    return;
  }

  if (canDowngrade) {
    if (isMixed) {
      onChange(`${name}.checked`, true);
      onChange(`${name}.isMixed`, false);
      return;
    }

    onChange(`${name}.checked`, false);
    onChange(`${name}.isMixed`, false);
    return;
  }

  onChange(`${name}.isMixed`, !isMixed);
};

export const updateViewOrDownloadForMember = (config: {
  name: string;
  isDownload: boolean;
  memberCurrentState: BulkFormAvailabilityMember;
  checked: boolean;
  onChange: (name: string, value: boolean) => void;
}) => {
  const {
    name,
    isDownload,
    checked,
    memberCurrentState: { view, download },
    onChange,
  } = config;

  if (isDownload) {
    const { state, isMixed, canDowngrade } = download;

    if (state === AVAILABILITY_STATE.OFF) {
      onChange(`${name}.download.checked`, checked);

      if (checked) {
        onChange(`${name}.view.checked`, true);
        onChange(`${name}.view.isMixed`, false);
      }

      return;
    }

    if (state === AVAILABILITY_STATE.ON) {
      if (canDowngrade) {
        onChange(`${name}.download.checked`, checked);

        if (checked) {
          onChange(`${name}.view.checked`, true);
          onChange(`${name}.view.isMixed`, false);
        }
      }

      return;
    }

    // mixed
    if (checked) {
      onChange(`${name}.download.checked`, true);
      onChange(`${name}.download.isMixed`, true);
      onChange(`${name}.view.checked`, true);

      if (
        view.state === AVAILABILITY_STATE.MIXED &&
        (!view.checked || (view.checked && view.isMixed))
      ) {
        onChange(`${name}.view.isMixed`, true);
      } else {
        onChange(`${name}.view.isMixed`, false);
      }

      return;
    }

    if (canDowngrade) {
      if (isMixed) {
        onChange(`${name}.download.checked`, true);
        onChange(`${name}.download.isMixed`, false);

        onChange(`${name}.view.checked`, true);
        onChange(`${name}.view.isMixed`, false);
        return;
      }

      onChange(`${name}.download.checked`, false);
      onChange(`${name}.download.isMixed`, false);
      return;
    }

    onChange(`${name}.download.isMixed`, !isMixed);

    if (isMixed) {
      onChange(`${name}.view.checked`, true);
      onChange(`${name}.view.isMixed`, false);
    }

    return;
  }

  const { state, isMixed, canDowngrade } = view;

  if (state === AVAILABILITY_STATE.OFF) {
    onChange(`${name}.view.checked`, checked);

    if (!checked) {
      onChange(`${name}.download.checked`, false);
      onChange(`${name}.download.isMixed`, false);
    }

    return;
  }

  if (state === AVAILABILITY_STATE.ON) {
    if (canDowngrade) {
      onChange(`${name}.view.checked`, checked);

      if (!checked) {
        onChange(`${name}.download.checked`, false);
        onChange(`${name}.download.isMixed`, false);
      }
    }

    return;
  }

  // mixed
  if (checked) {
    onChange(`${name}.view.checked`, true);
    onChange(`${name}.view.isMixed`, true);
    return;
  }

  if (canDowngrade) {
    if (isMixed) {
      onChange(`${name}.view.checked`, true);
      onChange(`${name}.view.isMixed`, false);
      return;
    }

    onChange(`${name}.view.checked`, false);
    onChange(`${name}.view.isMixed`, false);

    onChange(`${name}.download.checked`, false);
    onChange(`${name}.download.isMixed`, false);
    return;
  }

  onChange(`${name}.view.isMixed`, !isMixed);

  if (download.checked && !download.isMixed) {
    if (download.state === AVAILABILITY_STATE.MIXED) {
      onChange(`${name}.download.checked`, true);
      onChange(`${name}.download.isMixed`, true);

      return;
    }

    onChange(`${name}.download.checked`, false);
    onChange(`${name}.download.isMixed`, false);
  }
};

export const updateFromAllCheckboxValue = (config: {
  name: string;
  isDownload: boolean;
  memberCurrentState: BulkFormAvailabilityMember;
  checked: boolean;
  onChange: (name: string, value: boolean) => void;
}) => {
  const {
    name,
    isDownload,
    checked,
    memberCurrentState: { view, download },
    onChange,
  } = config;

  if (isDownload) {
    const { disabled, canDowngrade, state } = download;
    if (disabled) return;

    if (checked) {
      onChange(`${name}.download.checked`, true);
      onChange(`${name}.download.isMixed`, false);

      onChange(`${name}.view.checked`, true);
      onChange(`${name}.view.isMixed`, false);
      return;
    }

    if (canDowngrade) {
      onChange(`${name}.download.checked`, false);
      onChange(`${name}.download.isMixed`, false);
      return;
    }

    if (state === AVAILABILITY_STATE.MIXED) {
      onChange(`${name}.download.isMixed`, true);
      return;
    }
  }

  // VIEW
  const { disabled, canDowngrade, state } = view;
  if (disabled) return;

  if (checked) {
    onChange(`${name}.view.checked`, true);
    onChange(`${name}.view.isMixed`, false);
    return;
  }

  if (canDowngrade) {
    onChange(`${name}.view.checked`, false);
    onChange(`${name}.view.isMixed`, false);

    onChange(`${name}.download.checked`, false);
    onChange(`${name}.download.isMixed`, false);
    return;
  }

  if (state === AVAILABILITY_STATE.MIXED) {
    onChange(`${name}.view.isMixed`, true);

    if (download.checked) {
      if (download.state === AVAILABILITY_STATE.MIXED) {
        onChange(`${name}.download.checked`, true);
        onChange(`${name}.download.isMixed`, true);
        return;
      }

      onChange(`${name}.download.checked`, false);
      onChange(`${name}.download.isMixed`, false);
    }
  }
};
